import React from 'react';
import { createRoot } from 'react-dom/client';
import { setBooleanFeatureFlagResolver } from '@atlaskit/platform-feature-flags';
import { getDocument } from '@atlaskit/browser-apis';
import { App } from './ui/App';
import { initSentry } from '@atlassian/twg-microsite-experience';

// Initialise Sentry before rendering the app.
// Disabled in dev environments (localhost / development / local).
initSentry();

// Brute force new app logos
// eslint-disable-next-line @atlaskit/platform/no-module-level-eval
setBooleanFeatureFlagResolver((flagName) => flagName === 'platform-logo-rebrand');

const rootNode = getDocument()?.getElementById('pillar-root');

if (rootNode) {
	const root = createRoot(rootNode);
	root.render(<App />);
}
